const titleElement = document.querySelector("#title");
const smallTexts = document.querySelectorAll(".titleSmallText");
const smallTextSizes = new Array(smallTexts.length);
let animationStart = -2000;
let needsStart = false;
let finished = true;
let forward = true;
// export function setEndCallback(callback: () => void) {
//     this.animationEndCallback = callback;
// }
export function start() {
    if (forward) {
        startClose();
    }
    else {
        startOpen();
    }
}
export function startClose() {
    if (forward) {
        needsStart = true;
        forward = false;
        if (finished) {
            for (let i = 0; i < smallTexts.length; i++) {
                smallTextSizes[i] = smallTexts[i].offsetWidth;
            }
        }
    }
}
export function startOpen() {
    if (!forward) {
        needsStart = true;
        forward = true;
        // for(let i = 0; i < smallTexts.length; i++) {
        //     smallTextSizes[i] = (smallTexts[i] as HTMLSpanElement).offsetWidth;
        // }
    }
}
export function debugGetTimeThroughAnimation(timestamp) {
    return timestamp - animationStart;
}
function smoothFunc(x) {
    return 1 - Math.pow(1 - x, 3);
    // return 1 - Math.pow(1 - x, 3);
    // return x;
}
function invSmoothFunc(x) {
    return 1 - Math.pow(1 - x, 0.3);
}
export function renderAnimation(timestamp) {
    if (needsStart) {
        if (!finished) {
            // animationStart = timestamp - (1000 - (timestamp - animationStart));
            animationStart = timestamp - invSmoothFunc(1 - smoothFunc((timestamp - animationStart) * 0.001)) * 1000;
        }
        else {
            animationStart = timestamp;
        }
        needsStart = false;
        finished = false;
    }
    if (!finished) {
        let x = 0;
        if (forward) {
            x = smoothFunc((timestamp - animationStart) * 0.001);
        }
        else {
            x = 1 - smoothFunc((timestamp - animationStart) * 0.001);
        }
        if (timestamp - animationStart >= 1000) {
            finished = true;
        }
        else {
            for (let i = 0; i < smallTexts.length; i++) {
                smallTexts[i].style.width = (x * smallTextSizes[i]) + "px";
            }
        }
    }
    if (finished) {
        if (forward) {
            for (let i = 0; i < smallTexts.length; i++) {
                smallTexts[i].style.width = "";
            }
        }
        else {
            for (let i = 0; i < smallTexts.length; i++) {
                smallTexts[i].style.width = "0";
            }
        }
    }
}
